<template>
    <div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="类型:">
                    <el-select v-model="formData.lx_value" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.lx_options" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="create_time" label="日期" show-overflow-tooltip width="200"> </el-table-column>
                <el-table-column prop="label_text" label="问题分类" show-overflow-tooltip width="200"> </el-table-column>
                <el-table-column prop="content" label="内容" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="phone" label="电话" show-overflow-tooltip width="200"> </el-table-column>
                <el-table-column prop="source_text" label="详情" show-overflow-tooltip width="200">
                    <template slot-scope='scope'>
                        <el-button type="primary" size='small' @click="detailbtn(scope.row)">详情</el-button>
                        <el-button type="danger" size='small' @click="delbtn(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 反馈详情 -->
        <el-dialog title="反馈详情" :visible.sync="dialogVisible" center top="50px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="ruleForm" label-width="150px" class="demo-ruleForm forms-lines">
                    <el-form-item label="时间：" prop='ry_value'>
                        {{dataildata.create_time}}
                    </el-form-item>
                    <el-form-item label="类别：" prop='lb_value'>
                        {{dataildata.label_text}}
                    </el-form-item>
                    <el-form-item label="内容：" prop="textarea">
                        {{dataildata.content}}
                    </el-form-item>
                    <el-form-item label="电话：" prop="textarea">
                        {{dataildata.phone}}
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    docname: '',
                    lx_value: '',
                    doc_options: [],
                    lx_options: [

                    ],
                },
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                dialogVisible: false,
                date: xaoi.date,
                dataildata: {},
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getall()
            that.getHeight()
            that.getDate6()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/KkysKtFeedback/feedbackList", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        start_time: this.formData.time[0] ? this.formData.time[0] : '',
                        end_time: this.formData.time[1] ? this.formData.time[1] : '',
                        label_id: this.formData.lx_value,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            getall() {
                this.gettype()
            },
            gettype() {
                axios
                    .post("/admin/pc/KkysKtFeedback/labelSelect", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.lx_options = response.data.data
                    })
                    .catch(error => {})
            },
            //本月
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                this.formData.time = [start, end]
                that.begin()
            },
            detailbtn(row) {
                this.dataildata = row
                this.dialogVisible = true
            },
            delbtn(row) {
                let that=this
                this.$confirm('此操作将永久删除该条反馈, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.loading = true
                    axios
                        .post("/admin/pc/KkysKtFeedback/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.search()
                            }else{
                                this.$message(res.data.msg)
                                that.loading = false
                            }

                        })
                        .catch(error => {
                            that.loading = false
                        })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },


        },

    };
</script>


<style lang="scss" scoped>
 .index{
        border-radius: 6px;
        padding-bottom: 10px;
    }
</style>